// removed by extract-text-webpack-plugin
module.exports = {"container":"pMbpUIRoKLIQPcndzLB2M","block":"_2QJRR4zcsdaPOFcKJ97cJL","withImage":"_1RmqfL5kH31YUJPHdQJkWZ","quote":"qFzboFxwb-r7_Jh5pAzQP","yellow":"_2ywTQV25KMAN0wGUh6aUrb","blue":"N2Gb8J5V7_DYpEYw2kA7m","author":"JJhEr50GbR4fSv_Td93Cy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuoteBlock/QuoteBlock.module.scss
// module id = 802
// module chunks = 0